import { combineEpics } from 'redux-observable';
import { errorHandlingEpic } from '@/core/features/errorHandling/state/epics';
import { loaderEpic } from '@/core/features/loader/state/epics';
import { appEpic } from '@/slices/app/epics';
import { userEpic } from '@/slices/user/epics';
import { sportsEpic } from '@/slices/sports/epics';
import { matchesEpic } from '@/slices/matches/epics';
import { logosEpic } from '@/slices/logos/epics';

export default combineEpics(
  errorHandlingEpic,
  loaderEpic,
  appEpic,
  userEpic,
  sportsEpic,
  matchesEpic,
  logosEpic,
);
